import memoizeOne from "memoize-one";
import { ILinkConfigurationItem } from "../../backend/interfaces/configuration/IConfiguration";
import { IHierarchyItem } from "../../backend/interfaces/IItem";
import { getProperties } from "../../backend/helpers/itemHelpers";
import { getIdsFromLookupProperties } from "./helpers";

// Links to other items are merely references to other items (aka Lookup or MultiSelectLookup properties in M-files)
// Check configuration which property is used to determine links and create linksTo/linksFrom arrays accrodingly
export const deduceLinks = memoizeOne((linkConfigurations: ILinkConfigurationItem[], itemsMap: { [id: number]: IHierarchyItem }): {
  [id: number]: IHierarchyItem;
} => {
  const newItemsMap = { ...itemsMap };
  for (const item of Object.values(newItemsMap)) {
    newItemsMap[item.id] = { ...item, linksTo: [...item.linksTo], linksFrom: [...item.linksFrom] };
  }

  const items = Object.values(newItemsMap);
  for (const item of Object.values(newItemsMap)) {
    const suitableConfigurations = linkConfigurations.filter((c) => c.to === item.objectType);
    const properties = getProperties(
      item.properties,
      suitableConfigurations.map((c) => c.property)
    );
    const linksFromObjectIds = getIdsFromLookupProperties(properties);
    const linksFromIds: number[] = items.filter((i) => linksFromObjectIds.includes(i.objectId)).map((i) => i.id);

    for (const linkFromId of linksFromIds) {
      newItemsMap[linkFromId]?.linksTo.push(item.id);
      newItemsMap[item.id]?.linksFrom.push(linkFromId);
    }
  }

  return newItemsMap;
});
